import React from "react";
import styled from "@emotion/styled";
import { numberWithCommas, stringToDate } from "components/Travel/function";
import { countryName } from "components/Travel/country";
import DefinitionLine from "components/Common/PC/DefinitionLine";
import iconAirplane from "images/pc/icon-airplane.svg";

interface Props {
  data: any;
  index: number;
  match: any;
}

const ListCard: React.FunctionComponent<Props> = ({ data, index, match }) => {
  return (
    <LastTrip>
      <CountryImage>
        <img
          src={`${
            process.env.REACT_APP_S3_URL
          }/bomapp_30_b2b2c/travel/countries/thumb/img_${
            data.travelInfo.country
          }.jpg`}
          onError={(e: any) => {
            e.target.onerror = null;
            e.target.src = `${
              process.env.REACT_APP_S3_URL
            }/bomapp_30_b2b2c/travel/countries/thumb/img_default.jpg`;
          }}
          alt="country"
        />
      </CountryImage>
      <div className="lastTripInfo">
        <p className="lastDestination">
          대한민국
          <span className="iconAirplane">
            <img src={iconAirplane} alt="" />
          </span>
          {countryName(data.travelInfo.country)}
        </p>
        <DefinitionLine
          plainType={true}
          title="가입일시"
          content={data.insuranceDate}
        />
        <DefinitionLine
          plainType={true}
          title="보험기간"
          content={
            <>
              <span className="number">
                {stringToDate(data.policyStartDate)}
              </span>{" "}
              (<span className="number">{data.policyStartDateTime}</span>시)
              <span> ~ </span>
              <span className="number">
                {stringToDate(data.policyEndDate)}
              </span>{" "}
              (<span className="number">{data.policyEndDateTime}</span>시)
            </>
          }
        />
        <DefinitionLine
          plainType={true}
          title="가입인원"
          content={`${data.travelInfo.companionInfoList.length}명`}
        />
        <DefinitionLine
          plainType={true}
          title="보험료"
          content={`${numberWithCommas(data.totalAmount)}원`}
        />
      </div>
    </LastTrip>
  );
};

const LastTrip = styled.div`
  overflow: hidden;
  display: flex;
  margin-top: 12px;
  height: 170px;
  border-radius: ${props => props.theme.radius};
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);
  cursor: pointer;

  &.last {
    padding-bottom: 50px;
  }

  .lastDestination {
    margin-bottom: 10px;
    font-weight: ${props => props.theme.weight.extraBold};
  }

  .iconAirplane {
    display: inline-block;
    margin-left: 10px;
    margin-right: 10px;
    width: 20px;
    height: 14px;

    > img {
      margin-bottom: 2px;
      width: 100%;
      vertical-align: middle;
      object-fit: contain;
    }
  }

  .lastTripInfo {
    flex: 1 0 auto;
    padding-left: 28px;
    padding-top: 28px;
  }
`;

const CountryImage = styled.div`
  flex: 0 0 180px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export default ListCard;
